import React, { useContext, useState } from 'react';

import { ApiRoutes, FetchContext, HttpMethods, ToastContext } from '../../contexts';

import { ValoreRuoli, useAggregatedState } from '../../../helpers';

export const ContattiWizardContext = React.createContext(null);

const { Provider } = ContattiWizardContext;

export const ContattiWizardProvider = (props) => {
    const {
        showWarningMessage,
        showSuccessMessage,
        showErrorMessage,
        showLoadingMessage,
        closeLoadingMessage,
    } = useContext(ToastContext);
    const { user, fetchOk, fetchAuthorized } = useContext(FetchContext);
    const [state, setState] = useAggregatedState({
        ufficio: null,
        contatti: null,
        uffici: null,

        tipiContatti: null,
        tipiContattiOptions: [],

    });

    const [isLoadingContatti, setIsLoadingContatti] = useState(false);
    const getContattiAsync = async (ufficioId, pageIndex = 0, pageSize = 100, padreId = null) => {
        try {
            setIsLoadingContatti(true);
            const r = await fetchAuthorized(ApiRoutes.Ufficio.GetContatti({ ufficioId, padreId, pageIndex, pageSize }), {
                method: HttpMethods.GET
            });
            const list = await r.json();
            setState({ contatti: list, });
        } catch (e) {
            console.debug(e);
        } finally {
            setIsLoadingContatti(false);
        }
    }

    const [isLoadingTipiContatti, setIsLoadingTipiContatti] = useState(false);
    const getTipiContattiAsync = async (pageIndex = 0, pageSize = 100, term = null) => {
        try {
            setIsLoadingTipiContatti(true);
            const r = await fetchAuthorized(ApiRoutes.TipoContatto.GetTipiContatti({ pageIndex, pageSize, term }), {
                method: HttpMethods.GET
            });
            const list = await r.json();
            list.result = list.result.map(e => {
                return {
                    ...e,
                    inizioValidita: new Date(e.inizioValidita),
                    fineValidita: e.fineValidita ? new Date(e.fineValidita) : null,
                }
            });
            setState({
                tipiContatti: list, tipiContattiOptions: list.result.map(e => {
                    return { tipoContattoId: e.id, label: `${e.nome}` }
                }).sort((a, b) => a.label.localeCompare(b.label))
            });
        } catch (e) {
            console.debug(e);
        } finally {
            setIsLoadingTipiContatti(false);
        }
    }

    const [isUpdatingContatti, setIsUpdatingContatti] = useState(false);
    const updateContattiAsync = async (ufficioId, updateContattiDTO) => {
        if (updateContattiDTO.some(x => !x.tipoContattoId)) {
            showErrorMessage("Non è possibile aggiungere un attributo senza tipo");
            return;
        }
        setIsUpdatingContatti(true);
        try {
            const r = await fetchAuthorized(ApiRoutes.Ufficio.UpdateContatti({ ufficioId }), {
                method: HttpMethods.POST,
                body: JSON.stringify(updateContattiDTO),
            });
            showSuccessMessage("Contatti aggiornati");
        } catch (e) {
            console.debug(e);
        } finally {
            setIsUpdatingContatti(false);
        }
    }

    const [isLoadingUfficio, setIsLoadingUfficio] = useState(false);
    const getUfficioAsync = async (ufficioId) => {
        try {
            setIsLoadingUfficio(true);
            const r = await fetchAuthorized(ApiRoutes.Ufficio.GetUfficio({ ufficioId }), {
                method: HttpMethods.GET
            });
            const result = await r.json();
            result.inizioValidita = new Date(result.inizioValidita);
            result.fineValidita = result.fineValidita ? new Date(result.fineValidita) : null;
            setState({ ufficio: result });
        } catch (e) {
            console.debug(e);
        } finally {
            setIsLoadingUfficio(false);
        }
    }

    const [isUpdatingUfficio, setIsUpdatingUfficio] = useState(false);
    const updateUfficioAsync = async (ufficioId, ufficio) => {
        try {
            setIsUpdatingUfficio(true);
            const r = await fetchAuthorized(ApiRoutes.Ufficio.UpdateUfficio({ ufficioId }), {
                method: HttpMethods.POST,
                body: JSON.stringify(ufficio),
            });
            const result = await r.json();
            setState({ ufficio: result });
            showSuccessMessage(`Ufficio "${ufficio.nome}" convalidato`);
        } catch (e) {
            console.debug(e);
        } finally {
            setIsUpdatingUfficio(false);
        }
    }

    const [isLoadingUffici, setIsLoadingUffici] = useState(false);
    const getUfficiAsync = async (pageIndex = 0, pageSize = 10, notConvalidato = true) => {
        try {
            setIsLoadingUffici(true);
            const r = await fetchAuthorized(ApiRoutes.Ufficio.GetUffici(), {
                method: HttpMethods.POST,
                body: JSON.stringify({ pageIndex, pageSize, notConvalidato, tipiIds: user.ruolo.valoreRuolo == ValoreRuoli.Redattore ? user.utenteTipiUffici : null }),
            });
            const list = await r.json();
            setState({ uffici: list });
        } catch (e) {
            console.debug(e);
        } finally {
            setIsLoadingUffici(false);
        }
    }

    return (
        <Provider value={{
            state,
            setState,

            isLoadingContatti,
            getContattiAsync,

            isLoadingTipiContatti,
            getTipiContattiAsync,

            isUpdatingContatti,
            updateContattiAsync,

            isLoadingUfficio,
            getUfficioAsync,

            isUpdatingUfficio,
            updateUfficioAsync,

            isLoadingUffici,
            getUfficiAsync,

        }}>
            {props.children}
        </Provider>
    );
}